"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  maxWidth: 'unset',
  margin: theme.spacing(0, 3),
  [theme.breakpoints.up('md')]: {
    width: 600,
    maxWidth: 600,
    margin: '0 auto'
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)({
  textAlign: 'center',
  textTransform: 'uppercase'
});
